import { useState, useEffect } from "react";
import { Modal, Row, Form, Col, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import toastService from "../../_services/toastService";
import SatAPI from "../../_services/sat";

const api = SatAPI();

function EditModal({ data = {}, hideModal }) {
  const snapshot = useSelector(state => state.snapshot.fileName);

  const [name, setName] = useState(data.name || "");
  const [forfaitFactor, setForfaitFactor] = useState(data.forfaitFactor || 100);
  const [programmeType, setProgrammeType] = useState(data.programmeType || 0);
  const [credit, setCredit] = useState(data.credit ?? "");

  const [isCluster, setIsCluster] = useState(!!data.isCluster);
  const [useAllocationAsBudgetVte, setUseAllocationAsBudgetVte] = useState(!!data.useAllocationAsBudgetVte);
  const [clusterProgrammeId, setClusterProgrammeId] = useState(data.isCluster ? null : (data.clusterProgrammeId || null));
  const [clusterProgrammes, setClusterProgrammes] = useState([]);
  const [hasSubProgrammes, setHasSubProgrammes] = useState(false);

  useEffect(() => {
    api.getProgrammes().then(progs => {
      setClusterProgrammes(progs.filter(p => p.isCluster && p.ID !== data.ID));
      if (data.ID) {
        setHasSubProgrammes(progs.some(p => p.clusterProgrammeId === data.ID));
      }
    }).catch(() => setClusterProgrammes([]));
  }, []);

  const onFormSubmit = async e => {
    e.preventDefault();
    try {
      const payload = {
        name,
        forfaitFactor: forfaitFactor,
        programmeType,
        budgetFTE: data.budgetFTE || 0,
        isCluster,
        useAllocationAsBudgetVte,
        clusterProgrammeId: isCluster ? null : (clusterProgrammeId || null),
        credit: isCluster || !Number.isFinite(credit) ? null : credit,
      };

      if (data.ID) {
        await api.updateProgramme(data.ID, payload);
      } else {
        await api.createProgramme(payload);
      }
      //api.createSnapshot();
      toastService.send({ title: "Success", message: "Opleiding is opgeslagen" });
      hideModal();
    } catch (error) {
      toastService.send({ title: "An error occured", message: error });
    }
  };
  return (
    <Modal
      show
      onHide={() => {
        hideModal();
      }}
      backdrop="static"
      keyboard={false}
      centered
      size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Opleiding {data.ID ? "bewerken" : "aanmaken"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col xs={12}>
            <Form onSubmit={onFormSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Naam</Form.Label>
                <Form.Control type="text" required onChange={e => setName(e.target.value)} value={name} />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Type opleiding</Form.Label>
                <Form.Select onChange={e => setProgrammeType(parseInt(e.target.value, 10))} value={programmeType}>
                  <option value={0}>Bachelor</option>
                  <option value={1}>Graduaat</option>
                  <option value={2}>Andere</option>
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Forfait: 100% = ... uur</Form.Label>
                <Form.Control type="number" required onChange={e => setForfaitFactor(parseFloat(e.target.value))} value={forfaitFactor} />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Aantal studiepunten</Form.Label>
                {isCluster ? (
                  <div>
                    <Form.Control
                      type="text"
                      disabled
                      value=""
                    />
                    <Form.Text className="text-muted d-block mt-2">
                      Dit veld wordt automatisch berekend als de som van de studiepunten van de gekoppelde opleidingen.
                    </Form.Text>
                  </div>
                ) : (
                  <Form.Control type="number" step="0.1" onChange={e => setCredit(parseFloat(e.target.value))} value={credit} />
                )}
              </Form.Group>

              {programmeType === 2 && (
                <Form.Group className="mb-3">
                  <Form.Check
                    type="checkbox"
                    label="Gebruik Budgetbronnen-allocatie als Budget VTE"
                    checked={useAllocationAsBudgetVte}
                    onChange={e => setUseAllocationAsBudgetVte(e.target.checked)}
                    disabled={snapshot}
                  />
                </Form.Group>
              )}

              <Form.Group className="mb-3">
                <Form.Check
                  type="checkbox"
                  label="Dit is een cluster"
                  checked={isCluster}
                  onChange={e => {
                    setIsCluster(e.target.checked);
                    if (e.target.checked) setClusterProgrammeId(null);
                  }}
                  disabled={snapshot || (isCluster && hasSubProgrammes)}
                />
                {isCluster && hasSubProgrammes && (
                  <Form.Text className="text-danger d-block mt-1">
                    Er zijn nog opleidingen gekoppeld aan dit cluster. Ontkoppel ze eerst.
                  </Form.Text>
                )}
              </Form.Group>

              {!isCluster && (
                <Form.Group className="mb-3">
                  <Form.Label>Behoort tot cluster</Form.Label>
                  <Form.Select
                    value={clusterProgrammeId ?? ""}
                    onChange={e => setClusterProgrammeId(e.target.value ? parseInt(e.target.value, 10) : null)}
                    disabled={snapshot}
                  >
                    <option value="">— Geen cluster —</option>
                    {clusterProgrammes.map(p => (
                      <option key={p.ID} value={p.ID}>{p.name}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              )}

              <Button variant="primary" type="submit" disabled={snapshot}>
                {data.ID ? (
                  <span>
                    <i className="far fa-edit" />
                    &nbsp;Bewerk
                  </span>
                ) : (
                  <span>
                    <i className="far fa-plus" />
                    &nbsp;Aanmaken{" "}
                  </span>
                )}
              </Button>
            </Form>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}

export default EditModal;
